import styled, { css } from 'styled-components';
import { COLORS } from 'config/theme';

export const Container = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const Main = styled.div`
  width: 100%;
  height: 100vh;
  border-left: 1px solid ${COLORS.primaryLight};
  transition: 0.25s all;

  ${props => props.isOpen && css`
    width: calc(100% - 288px);
  `}
`;



// WEBPACK FOOTER //
// ./src/components/IterioApp/Users/Users.styles.js